/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SubOrderLite,
  SubOrderLiteFromJSON,
  SubOrderLiteFromJSONTyped,
  SubOrderLiteToJSON,
} from "./";

/**
 *
 * @export
 * @interface ForecastRequest
 */
export interface ForecastRequest {
  /**
   *
   * @type {Array<SubOrderLite>}
   * @memberof ForecastRequest
   */
  subOrders: Array<SubOrderLite>;
  /**
   *
   * @type {Array<string>}
   * @memberof ForecastRequest
   */
  conversionGroups: Array<string>;
}

export function ForecastRequestFromJSON(json: any): ForecastRequest {
  return ForecastRequestFromJSONTyped(json, false);
}

export function ForecastRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ForecastRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    subOrders: (json["subOrders"] as Array<any>).map(SubOrderLiteFromJSON),
    conversionGroups: json["conversionGroups"],
  };
}

export function ForecastRequestToJSON(value?: ForecastRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    subOrders: (value.subOrders as Array<any>).map(SubOrderLiteToJSON),
    conversionGroups: value.conversionGroups,
  };
}
